import React, { useEffect, useState } from "react";
import "./TechpubLinks.scss";
import { useTranslation } from "react-i18next";
import { faqLink, LOCATION_BREADCRUMB } from "../../../helper/constants";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ConfirmModalPopup from "./ConfirmModalPopup";
import AdminSite from "../AdminSite/AdminSite";
import { FacetFilterActions } from "../../../storage/reducers/facetFilterReducer";
import { utilAnalytics } from "../analytics/analyticsUtil";
import { cssReducer } from "../../../storage/reducers/cssGlobalReducer";
import { setMenuSelection } from "../../../storage/reducers/menuSelectorReducer";
import { deleteBreadcrumbCurrentPageNameFromSessionStorage } from "../breadcrumb/breadcrumbHelper";

export const TechpubsLinks = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showpopup, setShowPopup] = useState(false);
  const [navbarValue, setNavbarValue] = useState("");
  const urlPath = window.location.pathname.includes("/viewcollection");
  const tempRevUrl = window.location.pathname.includes("/temprevisions");
  const relatedpubUrl = window.location.pathname.includes("/relatedpub");
  const requestForm = window.location.pathname.includes("/subscription_request");
  const { mylibrary } = useSelector((state: any) => state.mylibrary);
  const selector = useSelector((state: any) => state.cssFlag);
  const [myLibraryLinkShow, setmyLibraryLinkShow] = useState(true);
  const { portalPermissions } = useSelector((state: any) => state.config);
  const techPubLinks = useSelector((state: any) => state?.filteredFacets?.techpubLinks);
  const { currentMenuSelection } = useSelector((state: any) => state?.menuSelector);
  const navigate = useNavigate();

  const setMenuOptionSelected = (option: string, title: string) => {
    dispatch(
      setMenuSelection({
        currentMenuSelection: option,
        currentMenuTitle: title
      })
    );
  };

  useEffect(() => {
    mylibrary?.result?.totalRecordsFromBMS != "0"
      ? setmyLibraryLinkShow(true)
      : setmyLibraryLinkShow(false);
    if (window.location.pathname === "/") {
      // setActive("/publicationSearch");
      setMenuOptionSelected("/publicationSearch", "");
    }
    // else {
    //   setActive(window.location.pathname);
    // }
  }, [techPubLinks, selector.cssFlag]);

  const handleClickLinkOption: any = (event: any, redirectVal: string) => {
    dispatch(
      FacetFilterActions.getSelectedFilterData({
        facetObjectVal: "",
        facetPayloadVal: "",
        redirecTechLink: redirectVal,
      })
    );

    dispatch(cssReducer(true));

    if (requestForm == true) {
      event.preventDefault();
      setShowPopup(true);
      setNavbarValue(redirectVal);
    } else {
      navigate(redirectVal, { replace: true });
    }

    if (redirectVal == "/publicationSearch" && !requestForm) {
      // setActive("/publicationSearch");
      setMenuOptionSelected("/publicationSearch", "");
      navigate("/");
      dispatch(
        FacetFilterActions.getSelectedFilterData({
          redirecTechLink: "/publicationSearch",
        })
      );
      if (window.location.pathname.includes("/")) {
        // setActive("/publicationSearch");
        setMenuOptionSelected("/publicationSearch", "");
      }
    } else if (redirectVal === "/" && requestForm) {
      setShowPopup(true);
      setNavbarValue(redirectVal);
    }
    // setActive(redirectVal);
    setMenuOptionSelected(redirectVal, "");
  };

  return (
    <>
      <ConfirmModalPopup
        show={showpopup}
        setShowPopup={setShowPopup}
        navigationbarVal={navbarValue}
      />
      <div
        className={
          urlPath || tempRevUrl || relatedpubUrl
            ? "AeroTechHeadlineRight viewcollection Psearch col-md-7"
            : "AeroTechHeadlineRight Psearch col-md-7"
        }
      >
        <div className="report-invoice">
          {/* Removed extra wrapping <a href="#"> that was causing double underline */}
          <Link
            to="/"
            className={currentMenuSelection === "/publicationSearch" ? "navbarActive" : ""}
            onClick={(e) => {
              handleClickLinkOption(e, "/publicationSearch");
              deleteBreadcrumbCurrentPageNameFromSessionStorage();
            }}
          >
            <span>{t(LOCATION_BREADCRUMB.PUBLICATIONS_SEARCH)}</span>
          </Link>
          <Link
            to="/downloads"
            onClick={(e) => {
              handleClickLinkOption(e, "/downloads");
              utilAnalytics(true, { linkName: "My Downloads" }, "/downloads");
            }}
            className={currentMenuSelection === "/downloads" ? "navbarActive" : ""}
          >
            <span>{t(LOCATION_BREADCRUMB.DOWNLOADS)}</span>
          </Link>
          <Link
            to="/favorites"
            className={currentMenuSelection === "/favorites" ? "navbarActive" : ""}
            onClick={(e) => {
              handleClickLinkOption(e, "/favorites");
              utilAnalytics(true, { linkName: "My Favorites" }, "/favorites");
            }}
          >
            <span>{t(LOCATION_BREADCRUMB.MY_FAVORITES)}</span>
          </Link>
          {myLibraryLinkShow && (
            <Link
              to="/subscriptions"
              className={currentMenuSelection === "/subscriptions" ? "navbarActive" : ""}
              onClick={(e) => {
                handleClickLinkOption(e, "/subscriptions");
                utilAnalytics(true, { linkName: "My Subscriptions" }, "/subscriptions");
              }}
            >
              <span>{t(LOCATION_BREADCRUMB.MY_LIBRARY)}</span>
            </Link>
          )}
          <Link
            to="/notifications"
            className={currentMenuSelection === "/notifications" ? "navbarActive" : ""}
            onClick={(e) => {
              handleClickLinkOption(e, "/notifications");
              utilAnalytics(true, { linkName: "My Email Notifications" }, "/notifications");
            }}
          >
            <span>{t(LOCATION_BREADCRUMB.MY_WATCHLIST)}</span>
          </Link>
          <a
            className={currentMenuSelection === "FAQ" ? "faq navbarActiveFaq" : "faq"}
            href={faqLink}
            target="_blank"
            onClick={(e) => {
              utilAnalytics(true, { linkName: "FAQ" }, `${faqLink}`);
            }}
          >
            {t(LOCATION_BREADCRUMB.FAQ)}&nbsp;
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.33334 10.8001V6.53318C1.33334 5.98419 1.33266 5.53226 1.36264 5.16534C1.39326 4.79064 1.45886 4.44591 1.62371 4.12238C1.87936 3.6207 2.2874 3.21266 2.78907 2.95701C3.11261 2.79216 3.45734 2.72656 3.83204 2.69594C4.19896 2.66596 4.65089 2.66665 5.19988 2.66665H6.66668C7.03487 2.66665 7.33334 2.96512 7.33334 3.33331C7.33334 3.7015 7.03487 3.99998 6.66668 3.99998H5.19988C4.62895 3.99998 4.24079 4.00021 3.94077 4.02472C3.64849 4.0486 3.49881 4.09204 3.39454 4.14516C3.14371 4.27298 2.93968 4.47701 2.81186 4.72784C2.75873 4.83211 2.7153 4.98179 2.69142 5.27407C2.66691 5.57409 2.66668 5.96226 2.66668 6.53318V10.8001C2.66668 11.371 2.66691 11.7592 2.69142 12.0592C2.7153 12.3515 2.75873 12.5012 2.81186 12.6054C2.93968 12.8563 3.14371 13.0603 3.39454 13.1881C3.49881 13.2413 3.64849 13.2847 3.94077 13.3086C4.24079 13.3331 4.62895 13.3333 5.19988 13.3333H9.46681C10.0377 13.3333 10.4259 13.3331 10.7259 13.3086C11.0182 13.2847 11.1679 13.2413 11.2721 13.1881C11.523 13.0603 11.727 12.8563 11.8548 12.6054C11.908 12.5012 11.9514 12.3515 11.9753 12.0592C11.9998 11.7592 12 11.371 12 10.8001V9.33331C12 8.96512 12.2985 8.66665 12.6667 8.66665C13.0349 8.66665 13.3333 8.96512 13.3333 9.33331V10.8001C13.3333 11.3491 13.334 11.801 13.304 12.1679C13.2734 12.5427 13.2078 12.8874 13.043 13.2109C12.7873 13.7126 12.3793 14.1206 11.8776 14.3763C11.5541 14.5411 11.2094 14.6067 10.8346 14.6374C10.4677 14.6673 10.0158 14.6666 9.46681 14.6666H5.19988C4.65089 14.6666 4.19896 14.6673 3.83204 14.6374C3.45734 14.6067 3.11261 14.5411 2.78907 14.3763C2.2874 14.1206 1.87936 13.7126 1.62371 13.2109C1.45886 12.8874 1.39326 12.5427 1.36264 12.1679C1.33266 11.801 1.33334 11.3491 1.33334 10.8001ZM14.6667 5.99998C14.6667 6.36817 14.3682 6.66665 14 6.66665C13.6318 6.66665 13.3333 6.36817 13.3333 5.99998V3.60935L9.13803 7.80467C8.87768 8.06502 8.45567 8.06502 8.19532 7.80467C7.93497 7.54432 7.93497 7.12231 8.19532 6.86196L12.3906 2.66665H10C9.63182 2.66665 9.33335 2.36817 9.33335 1.99998C9.33335 1.63179 9.63182 1.33331 10 1.33331H14C14.3682 1.33332 14.6667 1.63179 14.6667 1.99998V5.99998Z" fill="white"/>
            </svg>
            
          </a>
          {portalPermissions?.result?.isInternal === true && <AdminSite />}
        </div>
      </div>
    </>
  );
};
